// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { formGridProps } from "@store/Themes/common/props/form";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface FormStepProps {
    formGridContainer?: GridContainerProps;
    formGridItem?: GridItemProps;
    infoGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoLabel?: TypographyPresentationProps;
    infoValue?: TypographyPresentationProps;
}

export const formStepProps: FormStepProps = {
    formGridContainer: formGridProps.gridContainer,
    formGridItem: { width: [12, 6, 6, 6, 6] },
    infoGridContainer: formGridProps.gridContainer,
    infoGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
            gap: ${pxToRem(8)};
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    infoLabel: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    infoValue: {},
};
